// Types
import { Signal } from "signals";

// Models
import { DispatchOptions } from "Content/ts/Models/Shared/Signals/signalsModels";

class SignalsService {
    private attemptNumber: number; // Note: Shouldn't be accessible by the calling method

    // Purpose          :   Knockout Components don't load instantaneously, however if we try dispatching a call off the back of a 
    //                      subscription (example) then the context of the underlying Signal might not have been invoked intime. This
    //                      method is designed to recursively wait for a listener to be added before dispatching the callbak and 
    //                      terminiating the loop.
    // Usage            :   Use this method when you're passing a signal into a different component which depends on some event to finish
    //                      running before dispatching a call.
    // Example          :   Subscribing to an Event Type ID which retrieves the Clubs based on the selected object.
    // Documentation    :   http://millermedeiros.github.io/js-signals/docs/symbols/Signal.html
    RecursiveDispatch(signal: Signal, dispatchOptions?: DispatchOptions) {
        this.attemptNumber = this.attemptNumber || 1;

        const expectedTotalListeners = dispatchOptions != null && dispatchOptions.ExpectedTotalListeners != null ?
            dispatchOptions.ExpectedTotalListeners : 0;

        if (signal.getNumListeners() >= expectedTotalListeners) {
            signal.dispatch(dispatchOptions != null ? dispatchOptions.Options : null);

            return;
        } else {
            // Note: If by this point the we've iterated through this multiple times and a dispatch hasn't been found then stop the call 
            //       rather than have an infinite loop and potentially killing the browser.
            if (this.attemptNumber > 20) {
                this.attemptNumber = 1;
                return false;
            }

            // Note: Timeout is here as a rate limiter in order to give the calling object time to bind the signals dispatch method(s);
            setTimeout(() => {
                this.attemptNumber++;
                this.RecursiveDispatch(signal, dispatchOptions);
            }, 500);
        }
    };
}

var service = new SignalsService();
export { service as SignalsService };
